import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { AuthService } from '@examdojo/user';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'exam-no-access',
  imports: [ButtonComponent, IconComponent, TranslocoPipe],
  templateUrl: './no-access.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full items-center justify-center' },
})
export class NoAccessComponent {
  constructor(private readonly authService: AuthService) {}

  async signOut() {
    await this.authService.signOut();
  }
}
